import { DateHelper } from "../helpers/DateHelper";
import { IFilterDate } from "../store/FilterDates";

export class DateSerivce {
  /**
   *
   */
  public static getDaysForPanel(): IFilterDate[] {
    let remainingDays = DateHelper.getRemainingDaysOfWeek();
    if (remainingDays.length < 5) {
      const f = remainingDays.length;
      const nextWeekDate = new Date(Date.now() + 60 * 60 * 24 * 1000 * f);
      const nextWeekRemaidingDays =
        DateHelper.getRemainingDaysOfWeek(nextWeekDate);
      const neededDays = 5 - f;
      remainingDays = [
        ...remainingDays,
        ...nextWeekRemaidingDays.splice(0, neededDays),
      ];
    }
    return remainingDays;
  }
}
